(() => {
  if (window.ma12Accessories) return;
  window.ma12Accessories = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ma12-accessory-prev], [data-ma12-accessory-next]');
    if (!button) return;
    const track = button.closest('.ma3-cart-suggestions').querySelector('.ma7-accessory-track');
    const card = track.querySelector('.ma7-accessory');
    if (!card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    track.scrollBy({left: step * (button.hasAttribute('data-ma12-accessory-prev') ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
})();
